import global$1 from './global.js';
import isConstructor$1 from './is-constructor.js';
import tryToString$1 from './try-to-string.js';

var global = global$1;
var isConstructor = isConstructor$1;
var tryToString = tryToString$1;
var TypeError = global.TypeError; // `Assert: IsConstructor(argument) is true`

var aConstructor = function (argument) {
  if (isConstructor(argument)) return argument;
  throw TypeError(tryToString(argument) + ' is not a constructor');
};

export { aConstructor as default };
